import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ConfirmationDialog({ pendingToolCalls, onConfirm }) {
    const handleApproveAll = () => {
        const approvals = {};
        for (const tc of pendingToolCalls) {
            approvals[tc.toolCallId] = true;
        }
        onConfirm(approvals);
    };
    const handleDenyAll = () => {
        const approvals = {};
        for (const tc of pendingToolCalls) {
            approvals[tc.toolCallId] = false;
        }
        onConfirm(approvals);
    };
    return (_jsxs("div", { className: "confirmation-dialog", children: [_jsx("div", { className: "confirmation-header", children: "\u26A0\uFE0F Tool(s) require your confirmation" }), _jsx("ul", { className: "confirmation-tools", children: pendingToolCalls.map((tc) => (_jsxs("li", { children: [_jsx("strong", { children: tc.toolName }), _jsx("span", { className: "tool-desc", children: tc.description }), _jsx("pre", { className: "tool-args", children: JSON.stringify(tc.arguments, null, 2) })] }, tc.toolCallId))) }), _jsxs("div", { className: "confirmation-actions", children: [_jsx("button", { className: "btn-approve", onClick: handleApproveAll, type: "button", children: "\u2705 Approve All" }), _jsx("button", { className: "btn-deny", onClick: handleDenyAll, type: "button", children: "\u274C Deny All" })] })] }));
}
//# sourceMappingURL=ConfirmationDialog.js.map